import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { lsapIconColor } from '@models/lsap-icon-color.model';

@Component({
  selector: 'app-typography',
  standalone: true,
  imports: [
    NgClass,
    NgTemplateOutlet,
  ],
  templateUrl: './typography.component.html',
  styleUrl: './typography.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypographyComponent {
  type = input<'headline1' | 'headline2' | 'headline3' | 'headline4' |
    'body1' | 'body2' | 'landing-main-title' | 'landing-section-title' | 'inscription1' | 'inscription2' | 'inscription3'>('body1');
  color = input<lsapIconColor>();
  elType = input<'header' | 'text' | 'label'>();

  bold = input(false);

  get classes(): string[] {
    return [this.type(), this.color() ?? 'black', this.bold() ? 'bold' : ''];
  }
}
